/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgItalicK = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1834 128 937 953l578 839h-242l-504-758q-10-14-18-30t-16-32h-4l-173 820H358L710 128h202L746 910h4q14-14 27-28t28-29l765-725h264z"
    }));
export default SvgItalicK;
